import React, { FC } from 'react';
import { PageUiNavBar } from '../../components/Layout/PageNavBar/PageUiNavBar';

export const PlannerMenu: FC<{
  plannerLink?: string;
  limitedAccess?: boolean;
}> = ({ plannerLink, limitedAccess }) => {
  return (
    <PageUiNavBar
      bars={
        limitedAccess
          ? [
              {
                text: 'Planner',
                page: '/planner',
              },
            ]
          : [
              {
                text: 'Planner',
                page: '/planner',
              },
              {
                text: 'Inbound list',
                page: '/planner/print-list',
              },
              {
                text: 'Routes',
                page: '/planner/routes',
              },
              {
                text: 'Partitions',
                page: '/planner/partitions',
              },
              {
                text: 'Preferred Areas',
                page: '/planner/preferred-areas',
              },
              {
                text: 'Routing Debugger',
                page: '/planner/routing-debugger',
              },
            ]
      }
    />
  );
};
